import { Link } from 'react-router-dom';
import bannerImage from '../assets/img/banner_image.png';
import HeroThreeBackground from './HeroThreeBackground';

const motionSafe =
  'opacity-0 motion-reduce:translate-y-0 motion-reduce:opacity-100 motion-reduce:animate-none';

export default function Hero() {
  return (
    <section className="relative flex min-h-[90vh] items-center justify-center overflow-hidden pt-32 pb-16" aria-labelledby="hero-heading">
      {/* Background: oversized layer + slow Ken Burns (reference: cinematic corporate heroes) */}
      <div className="absolute inset-0 overflow-hidden" aria-hidden>
        <div
          className="absolute -inset-[15%] bg-cover bg-center bg-no-repeat motion-reduce:scale-100 motion-reduce:animate-none animate-hero-kenburns"
          style={{ backgroundImage: `url(${bannerImage})` }}
        />
      </div>
      {/* WebGL layer: gold particles + wireframe accent (Three.js) */}
      <HeroThreeBackground />
      {/* Readability + depth: static tint + subtle animated light (similar feel to premium group sites) */}
      <div
        className={`absolute inset-0 bg-gradient-to-b from-navy-950/50 via-navy-950/45 to-navy-950/60 motion-reduce:animate-none ${motionSafe} animate-fade-in [animation-duration:900ms]`}
        aria-hidden
      />
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-br from-gold/[0.07] via-transparent to-navy-950/50 motion-reduce:animate-none animate-hero-ambient"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_90%_70%_at_50%_25%,rgba(212,175,55,0.14),transparent_60%)] motion-reduce:animate-none animate-hero-radial"
        aria-hidden
      />
      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 sm:px-6 lg:px-8">
        {/* Intro — lighter weight like reference */}
        <div className={`w-full max-w-3xl space-y-2 text-center ${motionSafe} animate-fade-in-up`}>
          <p className="text-base font-light tracking-luxury text-white/95 sm:text-lg">
            We plan and execute your service
          </p>
          <p className="font-serif text-base font-medium italic leading-relaxed tracking-wide text-white/90 sm:text-lg">
            Bahrain&apos;s Leading Consultancy Services
          </p>
        </div>

        {/* Main headline — sans bold + serif italic gold */}
        <h1
          id="hero-heading"
          className={`mt-10 text-balance text-center font-sans text-3xl font-bold leading-[1.08] tracking-[0.01em] text-white sm:mt-12 sm:text-4xl md:text-5xl lg:text-6xl ${motionSafe} animate-fade-in-up [animation-delay:120ms]`}
       >
          <span className="font-sans font-bold tracking-luxury">Empowering </span>
          <span className="font-serif font-semibold italic tracking-luxury text-gold">Dreams,</span>{' '}
          <span className="font-sans font-bold tracking-luxury">Delivering </span>
          <span className="font-serif font-semibold italic tracking-luxury text-gold">Results</span>
        </h1>

        {/* Sub-headline 1 */}
        <p
          className={`mx-auto mt-8 w-full max-w-3xl text-center font-sans text-lg font-medium leading-relaxed tracking-wide text-white sm:text-xl md:text-2xl ${motionSafe} animate-fade-in-up [animation-delay:240ms]`}
        >
          Your Trusted Partner To Global Opportunities
        </p>

        <div
          className={`mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-5 ${motionSafe} animate-fade-in-up [animation-delay:380ms]`}
        >
          <Link
            to="/contact"
            className="inline-flex w-full min-w-[200px] items-center justify-center rounded-md bg-gold px-8 py-3.5 font-sans text-base font-semibold tracking-wide text-navy shadow-lg transition hover:bg-gold-light sm:w-auto"
          >
            Get Consultation
          </Link>
          <Link
            to="/services"
            className="inline-flex w-full min-w-[200px] items-center justify-center rounded-md border-2 border-white bg-transparent px-8 py-3.5 font-sans text-base font-semibold tracking-wide text-white transition hover:bg-white/10 sm:w-auto"
          >
            Our Services
          </Link>
        </div>
      </div>
    </section>
  );
}
